import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableButton from 'modules/Common/containers/Subscriptions/MyStableButton';

export default class ProfileHeading extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    classPrefix: PropTypes.string
  };

  render() {
    const {
      type,
      id,
      name,
      classPrefix = ''
    } = this.props;

    return (
      <div className={`${classPrefix}-profile-heading`}>
        <h1 className={`${classPrefix}-profile-heading1`}>{name}</h1>
        <div className={`${classPrefix}-profile-heading-my-stable`}>
          <SubscriptionContainer
            addSubscriptions={ [{ type, id, text: name }] }
            icon={ <MyStableButton /> }
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/ProfileHeading.js